"use client";

import { useState } from "react";
import { ContinuousCalendar } from "./ContinuousCalendar";
import { useSnack } from "./SnackProvider";
import MyChart from "./MyChart";
import SimpleModal from "./SimpleModal";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function DemoWrapper() {
  const { createSnack } = useSnack();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<{
    day: number;
    month: number;
    year: number;
  } | null>(null);

  const onClickHandler = (day: number, month: number, year: number) => {
    // const snackMessage = `Clicked on ${monthNames[month]} ${day}, ${year}`;
    // createSnack(snackMessage, "success");
    // setSelectedDate({ day, month, year });
    // // setModalOpen(true);
  };

  return (
    <main className="flex min-h-screen items-center justify-center">
      <div className="relative flex h-screen max-h-screen w-full flex-col gap-4 px-4 pt-4 items-center justify-center">
        <div className="relative h-full w-[inherit] overflow-auto ">
          <ContinuousCalendar onClick={onClickHandler} />
          <SimpleModal open={modalOpen} onClose={() => setModalOpen(false)}>
            {/* You can pass selectedDate to MyChart if you want to filter by date */}
            <h1>Appointment</h1>
            {/* <MyChart /> */}
          </SimpleModal>
        </div>
      </div>
    </main>
  );
}
